import { Box } from "@mui/material";
import React, { useMemo } from "react";

import { AppliedFilter } from "../../filters/filter-context";
import { useMonthActivityController } from "../controllers/use-month-activity-controller";
import { useWorkerActivityData } from "../controllers/use-worker-activity-data";
import MonthlyActivityTable from "./ui/monthly-activity-table";
import TableHeader from "./ui/table-header";

const MonthlyActivityReport = () => {
	const { currentUserId, workerActivityFilters, allMonthlyActivityReportData } = useWorkerActivityData();
	
	const [
		{
			date,
			filteredData,
			sidebarFilteredData,
			exportData,
			search,
			columnSelector,
			open,
			selectedKPI,
			KPICount,
		},
		{
			setDate,
			setSearch,
			setColumnSelector,
			setFilterOpen,
			setSelectedKPI,
		},
	] = useMonthActivityController();

	// Create default applied filters for Reporting Manager set to current user
	const defaultAppliedFilters = useMemo(() => {
		if (workerActivityFilters?.managers?.length > 0 && currentUserId) {
			// Find the current user in the managers list
			const currentUserManager = workerActivityFilters.managers.find(
				(manager) => manager.id.toString() === currentUserId.toString()
			);
			
			if (currentUserManager) {
				// Check if there's data for this reporting manager
				const hasData = allMonthlyActivityReportData?.some(
					worker => worker.reportingManagerId?.toString() === currentUserId.toString()
				);
				
				// Only apply filter if there's data available
				if (hasData) {
					return [{
						type: "Reporting Manager",
						timeAdded: Date.now(),
						data: [
							{
								id: currentUserManager.id.toString(),
								timeAdded: Date.now(),
								name: currentUserManager.name,
							},
						],
					}];
				}
			}
		}
		
		return [];
	}, [currentUserId, workerActivityFilters, allMonthlyActivityReportData]);

	return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "auto" }}>
      <TableHeader
        date={date}
        setDate={setDate}
        search={search}
        setSearch={setSearch}
        columnSelector={columnSelector}
        setColumnSelector={setColumnSelector}
        exportData={exportData}
        open={open}
        setFilterOpen={setFilterOpen}
      />
      <MonthlyActivityTable
        data={filteredData}
        search={search}
        columnSelector={columnSelector}
        isFilterOpen={open}
        selectedKPI={selectedKPI}
        setSelectedKPI={setSelectedKPI}
        KPICount={KPICount}
        defaultAppliedFilters={defaultAppliedFilters}
      />
    </Box>
  );
};

export default MonthlyActivityReport;
